import React from 'react';

import PageWrapperNoChrome from './PageWrapperNoChrome';
import PageWrapperChromed from './PageWrapperChromed';
import PreviewModeBanner from '../PreviewMode/PreviewModeBanner';

const PageWrapper = () => (
  <>
    <PreviewModeBanner />
    <PageWrapperNoChrome />
    <PageWrapperChromed />
  </>
);

export default PageWrapper;
